import {
  axiosGetNewToken
} from "@/api/auth";
const config = {
  config: "config",
  url: window.url,
  imgUrl: window.url,
  adminName: window.adminName,
  nameColors: {
    "0类": "rgba(252, 202, 82, 1)",
    "1类": "rgba(160, 230, 158, 1)",
    "2类": "rgba(97, 171, 255, 1)",
    "3类": "rgba(194, 105, 60, 1)",
    "4a类": "rgba(255, 89, 64, 1)",
    "4b类": "rgba(204, 69, 202, 1)",
  },
  nameColorsFunc: (v) => {
    const colors = {
      "0类": "rgba(252, 202, 82, 1)",
      "1类": "rgba(160, 230, 158, 1)",
      "2类": "rgba(97, 171, 255, 1)",
      "3类": "rgba(194, 105, 60, 1)",
      "4a类": "rgba(255, 89, 64, 1)",
      "4b类": "rgba(204, 69, 202, 1)",
    }
    let val = ''
    for (let key in colors) {
      if (v.indexOf(key) > -1 || v == key) {
        val = colors[key]
        break
      }
    }
    return val
  },
  reg: (v) => {
    return ('' + v).split(/<[^>]+>/gim).join("").split('').join("")
  },
  getArrKeys: (arr, k1, k2) => {
    let s = []
    arr.map(v => {
      s.push(`${v[k1]}${v[k2]?'('+v[k2]+')':''}`)
    })
    return s
  },
  setWind: (v) => {
    if (v >= 337.5 || v <= 22.25) return '北风'
    if (v >= 22.25 && v <= 67.5) return '东北风'
    if (v >= 67.5 && v <= 112.5) return '东风'
    if (v >= 112.5 && v <= 157.5) return '东南风'
    if (v >= 157.5 && v <= 202.5) return '南风'
    if (v >= 202.5 && v <= 247.5) return '西南风'
    if (v >= 247.5 && v <= 292.5) return '西风'
    if (v >= 292.5 && v <= 337.5) return '西北风'
  },
  settingElTable: (that, h) => {
    that.tableHeight = window.innerHeight - 144 - 70 - (h || 0);
    if (that.needPages) that.tableHeight = that.tableHeight - 40;
    that.tableSize = Math.floor((that.tableHeight - 40 * 1) / 40);
    that.pageSize = that.tableSize;
    that.pagination = {
      tableSize: that.tableSize,
      pageSize: that.pageSize,
      pageIndex: 1,
    }
    window.addEventListener("resize", () => {
      that.tableHeight = window.innerHeight - 144 - 70 - (h || 0);
      if (that.needPages) {
        that.tableHeight = that.tableHeight - 40;
      }
      that.tableSize = Math.floor((that.tableHeight - 40 * 1) / 40);
      that.pageSize = that.tableSize;
      that.pagination.tableSize = that.tableSize
      that.pagination.pageSize = that.pageSize
      // that.pagination.pageIndex = that.pageIndex
    });
  },
  dataStr: (value, title) => {
    if (value === null || value === '' || value === undefined) {
      return '-'
    } else {
      if (title) {
        return value
      } else {
        return value
      }
    }
  },
  chartColors: [
    "rgb(17, 130, 251)",
    "rgba(103, 207, 181, 1)",
    "rgba(255, 141, 26, 1)",
    "rgba(189, 214, 0, 1)",
    "rgba(210, 0, 64, 1)",
    "rgba(207, 103, 205, 1)",
    "rgba(92, 14, 227, 1)",
    "rgba(98, 209, 63, 1)",
    "rgba(135, 72, 72, 1)",
  ],
  levelColor: {
    '无效': '#999',
    '优': "#62D13F",
    '良': "#F5CB2A",
    '轻度污染': "#FF7E00",
    '轻度': "#FF7E00",
    '中度污染': "#FF401A",
    '中度': "#FF401A",
    '重度污染': "#D20040",
    '重度': "#D20040",
    '严重污染': "#9C0A4E",
    '严重': "#9C0A4E",
    'bg无效': 'rgba(153,153,153,.2)',
    'bg优': 'rgba(98,209,63,.2)',
    'bg良': "rgba(245,203,42,.2)",
    'bg轻度污染': 'rgba(255,126,0,.2)',
    'bg轻度': 'rgba(255,126,0,.2)',
    'bg中度污染': 'rgba(255,64,26,.2)',
    'bg中度': 'rgba(255,64,26,.2)',
    'bg重度污染': 'rgba(210,0,64,.2)',
    'bg重度': 'rgba(210,0,64,.2)',
    'bg严重污染': 'rgba(156,10,78,.2)',
    'bg严重': 'rgba(156,10,78,.2)',
    '-': '#999'
  },
  rank: (property) => {
    return function (a, b) {
      var value1 = a[property];
      var value2 = b[property];
      return value2 - value1;
    }
  },
  getWeekDay: (day) => {
    let date = new Date(day)
    var weekDay = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
    return weekDay[date.getDay()]
  },
  // 字符串截取
  strSlice: (txt, num, ellipsis = true) => txt.length > num ? txt.slice(0, num) + (ellipsis ? '...' : '') : txt,
  // 刷新token
  getNewToken(_this, requestFunc) {
    let token = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')).refreshToken : ''
    if (token) {
      axiosGetNewToken({
        token
      }).then(res => {
        if (typeof requestFunc === 'function' && !requestFunc) {
          alert('_this指向错误')
        }
        if (!_this) {
          window.location.replace()
        }
        // window.resTokenKey = 0
        if (_this.$route.path != '/login') {
          if (!res || !res.result) {
            localStorage.removeItem("token")
            localStorage.removeItem("userInfo")
            _this.$router.push({
              path: "/login"
            });
          } else {
            //重新获取token
            localStorage.setItem("token", res.result); //重置token
            requestFunc()
          }
        }
      })
    } else {
      localStorage.removeItem("token")
      localStorage.removeItem("userInfo")
      _this.$router.push({
        path: "/login"
      });
    }
  },
  // 导出文件公共方法
  exportData(_this, fileName) {
    _this.exportFlag = false
    setTimeout(() => {
      let excelName = `${fileName}.xlsx`;
      var xlsxParam = {
        raw: true
      }; //转换成excel时，使用原始的格式
      // 克隆节点
      // let tables = document.getElementById("out-table").cloneNode(true);
      // let tables = document.getElementsByClassName('el-table')[0].cloneNode(true);
      let tables = _this.$refs.exportTable.cloneNode(true);
      // 判断是否为固定列，解决（为固定列时，会重复生成表格）
      let table_book = _this.$XLSX.utils.table_to_book(tables, xlsxParam);
      var table_write = _this.$XLSX.write(table_book, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        _this.$FileSaver.saveAs(
          new Blob([table_write], {
            type: "application/octet-stream"
          }),
          excelName
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, table_write);
      }
      setTimeout(() => {
        _this.$store.dispatch('store/setLoading', false)
        _this.exportFlag = true
      }, 100);
    });
  },
};
export default config;



// WEBPACK FOOTER //
// ./src/util/config.js